var _excluded = ["dictType", "dictMap", "value", "type", "className"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useCssInJs } from "../../../hooks";
import { FormPath } from '@formily/core';
import { useField } from '@formily/react';
import cx from 'classnames';
import { useDictMap } from "../../Form/dict";
import { getDictStateStyle } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LeftDotBg = function LeftDotBg(props) {
  var label = props.label,
    isHaveLabel = props.isHaveLabel,
    color = props.color,
    className = props.className,
    style = props.style;
  return isHaveLabel ? /*#__PURE__*/_jsxs("div", {
    className: 'leftDotBg',
    children: [/*#__PURE__*/_jsx("div", {
      className: 'dot',
      style: style ? style : {
        backgroundColor: color === null || color === void 0 ? void 0 : color.borderColor
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "label",
      children: label
    })]
  }) : null;
};
export var DictState = function DictState(props) {
  var prefix = 'dict-state';
  var dictType = props.dictType,
    dictMap = props.dictMap,
    value = props.value,
    type = props.type,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var field = useField();
  var enums = field && field.dataSource;
  var map = useDictMap(dictType);
  var label = map && map[value] ? map[value].label : value;
  var ext = FormPath.getIn(map[value], 'origin.ext') || {};
  var _ext$color = ext.color,
    color = _ext$color === void 0 ? {} : _ext$color,
    style = ext.style;
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getDictStateStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  return wrapSSR( /*#__PURE__*/_jsx("div", {
    className: cx(prefix, hashId),
    children: map && map[value] ? /*#__PURE__*/_jsx(LeftDotBg, {
      label: label,
      isHaveLabel: true,
      color: color,
      className: className,
      style: style
    }) : null
  }));
};